{
    "account.admin_moderation_dash_settings": "Configuraziuns dal dashboard da moderaziun",
    "account.notification.email.moderationdecisions": "Decisiun da moderaziun",
    "account.notification.email.replies": "Respostas",
    "account.title": "Account",
    "account_delete.confirm_description": "Sche Voss profil vegn stizzà na po quai betg vegnir revocà. Da stizzar tut las datas e tut las activitads ch'èn colliadas cun il profil po durar fin 72 uras.",
    "account_delete.confirm_heading": "Essas Vus segirs che Vus vulais stizzar Vossas datas da profil?",
    "account_delete.description": "Sin dumonda vegnan stizzads la cronologia da Voss conto e Vossa participaziun a discussiuns en il rom da la dumonda. Questa acziun na po betg vegnir revocada.",
    "action.delete": "Stizzar",
    "action.open_teaser_positioning": "Administrar posiziunament da teasers",
    "action.post": "Contribuir",
    "action.save": "Arcunar",
    "admin_mod_link.developer_tools_label": "Tools per devs",
    "admin_mod_link.editorial_dashboard_description": "Administrar secturs e dapli.",
    "admin_mod_link.editorial_dashboard_label": "Dashboard da redacziun",
    "admin_mod_link.moderation_dashboard_description": "Moderaziun da discussiuns en il dashboard nov. (WIP)",
    "admin_mod_link.moderation_dashboard_label": "Dashboard da moderaziun",
    "admin_mod_link.settings_description": "Administrar la configuraziun e las funcziuns da l'organisaziun.",
    "admin_mod_link.settings_label": "Configuraziun",
    "admin_mod_link.storybook_description": "Vesair cumponentas da PSI en Storybook.",
    "agree": "Plitost d'accord",
    "aitag.ai_moderated": "Moderaziun cun IA",
    "article.admin_only_error": "Per vesair quest cuntegn stuais Vus esser colliads sco admin.",
    "article.login_button": "As colliar (log in)",
    "article.no_teaser_error": "Teaser betg definì",
    "audience_input_template.description": "Mettai ad ir la participaziun cun invitar il public da parter istorgias, testimonis e dumondas.",
    "audience_input_template.label": "Input dal public (AMA)",
    "blocklist.add_terms": "Agiuntar terms - separar plirs cun ;",
    "blocklist.description": "Administrar pleds che duessan vegnir rapportads automaticamain.",
    "button.react_button_aria": "{count} {tLabel} ({tSelected})",
    "button.react_button_deselected": "deselecziunà",
    "channels.no_channel": "Nagin chanal",
    "comment.confirm_leave_description": "Las midadas na vegnan betg arcunadas.",
    "comment.confirm_leave_heading": "Propi bandunar la pagina?",
    "comment.delete_button": "Stizzar",
    "comment.post_button": "Publitgar",
    "comment.public_comment_subtitle": "Commentari public",
    "comment.updating": "Vid actualisar…",
    "comment_slider.change_vote_button": "Actualisai Vossa resposta",
    "comment_slider.its_complicated": "Igl è cumplitgà",
    "comment_slider.no_with_reservations": "NA cun resalvas",
    "comment_slider.recording_vote": "Vid prender si il votum...",
    "comment_slider.share_thoughts": "Partai Voss patratgs",
    "comment_slider.skip_change_vote": "Sursiglir e midar votum",
    "comment_slider.skip_submit_vote": "Sursiglir e votar",
    "comment_slider.slide_to_respond": "Stuschar per respunder:",
    "comment_slider.strongly_no": "Cleramain NA",
    "comment_slider.strongly_yes": "Cleramain GEA",
    "comment_slider.update_response": "Actualisai Vossa resposta",
    "comment_slider.yes_with_reservations": "GEA cun resalvas",
    "comment_slider_template.description": "Supplichar las utilisad:ras da respunder a la dumonda sin in spectrum.",
    "comment_slider_template.label": "Slider da respostas",
    "community_guidelines.category_engage_respectfully": "As cumportai cun respect",
    "community_guidelines.category_no_disruptive_behavior": "Nagin cumportament che disturba",
    "community_guidelines.category_no_harmful_content": "Nagins cuntegns che fan donn",
    "community_guidelines.category_support_claims": "Annotai mussaments per Vossas pretensiuns",
    "community_guidelines.modal_heading": "Reglas da la community e cundiziuns d'utilisaziun",
    "community_guidelines.modal_intro": "Nus vulain pussibilitar in barat amicabel e constructiv. Perquai duain tuts sa sentir bainvegnids da parter lur puncts da vista ed experientschas. Vus pudais contribuir a la discussiun cun contribuziuns che han da far cun il tema ed èn relevantas, inclusiv critica constructiva. S'orientai vid las directivas da la community ed il codex da cumportament.",
    "community_guidelines.rule_avoid_derogatory_labels": "Evitai etichettas pegiurativas",
    "community_guidelines.rule_avoid_sarcasm": "Evitai sarcassem, respostas senza respect u che offendan",
    "community_guidelines.rule_explain_constructively": "Emprovas d'exprimer critica a moda constructiva",
    "community_guidelines.rule_express_civility": "Communicai er en conversaziuns stgaudadas adina cun respect",
    "community_guidelines.rule_focus_on_ideas": "Sa concentrai sin ideas ed arguments enstagl da giudicaments da caracter",
    "community_guidelines.rule_no_illegal_content": "Nagins cuntegns indecents, plain odi u illegals",
    "community_guidelines.rule_no_offtopic": "Naginas contribuziuns che n'han betg da far cun il tema",
    "community_guidelines.rule_no_spam": "Nagin spam e nagina reclama",
    "community_guidelines.rule_no_violent_content": "Nagins cuntegns ch'appelleschan a u che glorifitgeschan la violenza",
    "community_guidelines.rule_provide_sources": "Annotai pretensiuns cun funtaunas",
    "community_guidelines.rule_respect_privacy": "Respectai la sfera privata dad auters, betg tradir datas persunalas",
    "community_guidelines.title": "Directivas da la community e codex da cumportament",
    "community_guidelines.what_happens_heading": "Tge capita sche Vossa contribuziun cuntrafa a las directivas da la community u al codex da cumportament?",
    "context_entry_points.joined_from": "Vegn da",
    "conversation_helper.about": "Infurmaziuns davart il gidanter da conversaziun",
    "conversation_helper.disagree": "Plitost betg d'accord",
    "conversation_helper.generated_by_ai": "Questas indicaziuns vegnan generadas dad IA.",
    "conversation_helper.hello_everyone": "Assistent IA",
    "conversation_helper.new_comments_since_analysis": "- **{count} nov(s) commentari(s)** dapi l'ultima analisa",
    "conversation_helper.open_admin_dashboard": "Avrir dashboard d'admin",
    "conversationhelper.ai.hint": "Per mantegnair in'atmosfera envidanta e da respect utilisain nus l'IA era per sustegnair la moderaziun. L'IA dat tips per ina atmosfera da conversaziun pli constructiva e resumescha la conversaziun.",
    "dashboard.table.demo.users": "Vesair entaifer il spazi",
    "demo.disagree": "Plitost betg d'accord",
    "demo.tile_topics_label": "Temas",
    "dialogue_template.description": "Dumandar las utilisad:ras da respunder cun in simpel 'gea' u 'na'.",
    "dialogue_template.label": "Debatta",
    "disagree": "Plitost betg d'accord",
    "editorial_dash.title": "Dashboard da redacziun",
    "editorial_question.join_discussion": "Prendai part a la debatta",
    "editorial_question.lets_talk": "Prendai part a la conversaziun",
    "editorial_question.share_thoughts": "Cundividai Voss patratgs",
    "form.add_button": "Agiuntar",
    "form.create_space_button": "Crear il spazi",
    "form.delete_button": "Stizzar",
    "form.required_label": "{label} (obligatoric)",
    "form.save_button": "Arcunar",
    "invite_user.modal.subheading": "Envida insatgi d'esser in [redactional user](https://newpublic.notion.site/Technical-support-2e7fbd65fb3e80e39f11f750d0f5b129) en ils tools da PSI.",
    "list.selected_items_count": "{keyCount} elements selecziunads",
    "login.account_blocked_explanation": "Per la beta na dovri nagina acziun. Be in moderatur po restabilir Voss access a la discussiun.",
    "login.account_blocked_heading": "Vus na pudais betg As annunziar, perquai che Voss conto è bloccà",
    "login.account_not_impacted": "Voss conto da {siloName} n'è betg pertutgà ed è anc adina accessibel.",
    "login.cookie_notice": "🍪 Quest spazi da discussiun dovra mo cookies necessaris. Nus na duvrain nagins cookies per raschuns da reclama. [Dapli infurmaziuns]({privacyNoticeLink}).",
    "login.default_admin_login_subheading_label": "As colliai (log in) cun Voss conto d'admin per entschaiver.",
    "login.logging_in": "Vid colliar…",
    "modal.close_button": "Serrar",
    "modal.info_title": "Info",
    "moderation.add_explanation_to_user": "Agiuntar in messadi per l'utilisad:ra",
    "moderation.ai_mistake_explanation": "IA ans gida da moderar commentaris, po dentant mintgatant far sbagls. Sche l'IA impedescha Vus d'exprimer in'opiniun exprimida cun respect, pudais Vus dumandar in moderatur da verifitgar il commentari.",
    "moderation.ai_wrong_question": "Ha l'IA fatg in sbagl?",
    "moderation.check_your_thing": "⚠️ ️Controllai Voss {moderatedThing}",
    "moderation.dash.block_user": "Bloccar persuna",
    "moderation.dash.judgement_card.moderate": "Controllar",
    "moderation.dash.time": "Giada",
    "moderation.dash.times": "Giadas",
    "moderation.dash.user_must_be_warned_2_times": "Persunas ston vegnir admonidas 2 giadas avant ch'ellas pon vegnir bloccadas.",
    "moderation.dash.user_successfully_blocked": "{user} è vegnida blocca:da cun success",
    "moderation.explanations_sent_by_email": "Ils motivs vegnan transmess a l'utilisad:ra per e-mail suenter che la contribuziun è vegnida refusada",
    "moderation.incompatible_warning": "L'examinaziun cun IA ha mussà che Voss {moderatedThing} na correspunda forsa betg a las [Community-Guidelines]($onPress): ",
    "moderation.info_ai_moderation_banner_text": "Per garantir in ambient amiaivel e plain respect utilisain nus l'IA per moderar commentaris. L'IA marchescha Vossa contribuziun eventualmain per che Vus pudais anc ina giada examinar sch'ella na correspunda betg a las [Community-Guidelines]($onPress).",
    "moderation.message_to_moderator_placeholder": "Messadi al team da moderaziun...",
    "moderation.mode_ai": "Moderaziun cun IA",
    "moderation.mode_ai_and_manual": "Moderaziun IA e manuala",
    "moderation.mode_ai_post_anyway": "Moderaziun IA e tuttina postar",
    "moderation.perspective_label": "Puncts da vista differents",
    "moderation.provide_details_help": "Inditgai per plaschair tut ils detagls che pudessan ans gidar a constatar, sche Vossa contribuziun correspunda a nossas directivas.",
    "moderation.response": "Resposta",
    "moderation.send_for_review_button": "Trametter al team da moderaziun per laschar controllar",
    "moderation.send_to_moderator_button": "Trametter al team da moderaziun",
    "moderation.send_to_moderator_title": "Trametter al team da moderaziun",
    "moderation.sending": "Vid trametter...",
    "moderation.sent_for_review_message": "Vossa contribuziun è vegnida tramessa a noss team da moderaziun per laschar controllar.",
    "moderation.sent_to_moderator": "La contribuziun è vegnida tramessa a noss team da moderaziun per laschar controllar.",
    "moderation.share_details": "Parter detagls",
    "moderation.strict_filter_notice": "⚠️️ Il mument è noss filter da moderaziun configurà plitost strict per garantir che la community restia uschè segira sco pussaivel. En cas che Vus avais il sentiment che Vossa contribuziun saja vegnida refusada nungiustifitgadamain, As drizzai per plaschair a noss team da moderaziun.",
    "moderation.thank_you": "Grazia fitg!",
    "moderation.under_review": "Vegn controllà",
    "moderation.use_ai_title": "✨ Noss team da moderaziun ha sustegn da IA.",
    "moderation.what_guideline_violate": "A tge regla da la netichetta cuntrafa la contribuziun? Selecziunai tut las opziuns che correspundan.",
    "moderation.write_additional_explanation": "Motivai daco che la contribuziun vegn refusada",
    "moderationdash.title": "Dashboard da moderaziun",
    "most_popular.most_recent_label": "Ils ultims",
    "navigation_header.back_button": "Enavos",
    "original_language": "Linguatg original",
    "pagination_row.next_page": "Proxima pagina",
    "perspectives.add_your_own": "Formulai Voss punct da vista",
    "perspectives.dont_see_one": "Nagut che giess per Vus?",
    "perspectives.enter_label_placeholder": "Agiuntai in'etichetta da punct da vista",
    "perspectives.how_relate_question": "Co stais Vus tar quest tema?",
    "perspectives.share_thoughts_button": "Cundividai Voss patratgs",
    "pin_comment.feature_label": "Accentuar en il teaser",
    "pin_comment.featured_label": "Accentuà en il teaser",
    "pin_to_feed.move_down": "Spustar engiu",
    "pin_to_feed.move_up": "Spustar ensi",
    "poll.change_vote_button": "Modifitgar la selecziun",
    "poll.result_vote": "{tLabel}: {percent}%",
    "poll.result_your_vote": "{tLabel} (Vossa vusch): {percent}%",
    "poll.submit_vote_button": "Votar",
    "poll.write_in_topic": "Proponi in tema…",
    "poll.you_comment": "Vus ({comment})",
    "poll_question.add_option_button": "Agiuntar in'opziun",
    "poll_question.option_placeholder": "Endatar l'opziun…",
    "poll_question.options_label": "Opziuns da resposta",
    "poll_question.question_label": "Dumonda per l'enquista",
    "poll_question.question_placeholder": "Scriva la dumonda per l'enquista...",
    "poll_result.percent": "{percent}%",
    "privacy.only_visible_to_you": "🔒 Visibel mo per Vus",
    "profile.add_custom_name": "Agiuntar in pseudonim",
    "profile.beta_feedback_note": "Sche Vus participais a nossa versiun beta pudessi esser che nus As envidain d'ans trametter feedback davart Vossas experientschas cun quest product.",
    "profile.collaboration_note": "Quest spazi da discussiun vegn fatg il hosten da New_ Public en collavuraziun cun {psmName}.",
    "profile.consent_text": "Jau accept las [Community-Guidelines]({communityGuidelinesLink}) ed ils [Terms of Use]({termsOfServiceLink}). Jau hai prendì per renconuschientscha ils [Privacy Notice]({privacyNoticeLink}).",
    "profile.error_name_empty": "Il pseudonim na po betg esser vid.",
    "profile.error_name_invalid": "Nums creads da l'utilisad:ra pon cuntegnair mo bustabs pitschens e cifras.",
    "profile.error_name_looks_real": "Pseudonims na dastgan betg sumegliar a nums reals.",
    "profile.error_name_taken": "Quest num d'utilisad:ra vegn gia duvrà.",
    "profile.error_name_violates": "Il num giavischà cuntrafa eventualmain a nossa netichetta.",
    "profile.helper_text": "Tscherni in num ed in maletg da profil che vegnan mussads, sche Vus As participai a debattas.",
    "profile.is_titled_writer": "Mussar il titel da la persuna",
    "profile.module_photo_and_name": "Num",
    "profile_answers.admins_can_view": "Noss team da moderaziun po da tut temp vesair Vossa cronologia.",
    "profile_answers.discussion_history": "Cronologia da conversaziun",
    "profile_answers.history_private": "La cronologia da quest profil è privata",
    "profile_answers.rejected": "La contribuziun è vegnida refusada d'ina moderatur:a",
    "profile_answers.under_review": "Contribuziun vegn controllada",
    "profile_answers.visible_to_everyone": "Visibel per tut:tas",
    "question.actions.close_button": "Serrar",
    "question.actions.close_confirm_button": "Serrar",
    "question.actions.copy_button": "Copiar il link",
    "question.actions.reopen_modal_description": "Reavrir quest spazi per cuntinuar la conversaziun.",
    "question.add_content_label": "Agiuntar cuntegn",
    "question.add_spaces_label": "Agiuntar spazis",
    "question.all_responses_tab": "Tuttas contribuziuns",
    "question.edit_closed_banner": "Reavrir il spazi per l'editar.",
    "question.edit_thread_header_section": "Chau dal spazi",
    "question.input_placeholder": "Cundividai Voss patratgs...",
    "question.moderation_approach": "Metoda da moderaziun",
    "question.moderation_label": "Moderaziun",
    "question.moderation_section": "Moderaziun",
    "question.prompt_label": "Prompt",
    "question.prosocial_format_label": "Gener da conversaziun",
    "question.reply_plural": "respostas",
    "question.reply_singular": "resposta",
    "question.upvote_singular": "votum en favur",
    "question.your_response_title": "Vossa contribuziun",
    "rating.its_complicated": "Igl è cumplitgà",
    "rating.no_with_reservations": "Na cun resalvas",
    "rating.strongly_no": "Na",
    "rating.strongly_yes": "Gea",
    "rating.yes_with_reservations": "Gea cun resalvas",
    "reaction_types.controversial": "Cuntravers",
    "reaction_types.empathetic": "Empatic",
    "reaction_types.enjoyable": "Plaschaivel",
    "reaction_types.funny": "Legher",
    "reaction_types.nuanced": "Differenzià",
    "reaction_types.playful": "Ludic",
    "reaction_types.reaction_set_label": "Set da reacziuns",
    "reaction_types.relatable": "Sent jau era uschia",
    "reaction_types.why_appreciate": "Daco As plascha questa contribuziun?",
    "related_content.add_content_button": "Agiuntar cuntegn",
    "related_content.invalid_url_error": "Format da l'URL betg valaivel. Per plaschair endatar ina URL valaivla.",
    "related_content.label": "Cuntegn parentà",
    "related_content.retrieve_article_error": "Infurmaziuns da l'artitge na pon betg vegnir dumandadas giu. Per plaschair controllar la URL ed empruvar anc ina giada.",
    "related_content.show_more_button": "Mussar dapli",
    "related_content.story_format_label": "Gener da cuntegn",
    "related_content.story_url_label": "URL dal cuntegn",
    "related_conversations.add_hint": "Agiuntar fin a quatter spazis.",
    "related_conversations.limit_reached_error": "Quest spazi ha gia quatter spazis colligads tschernids. Allontanai in avant che agiuntar in auter.",
    "related_conversations.no_spaces_available": "Nagin spazi disponibel",
    "related_conversations.participant_plural": "participant:as",
    "related_conversations.participant_singular": "participant:a",
    "related_conversations.search_placeholder": "Tschertgar",
    "representing_perspectives_template.description": "Dumandar las utilisad:ras da respunder ord in tschert punct da vista.",
    "representing_perspectives_template.description_1": "Tscherna **3-5 puncts da vista concrets** dals quals Vus vulais udir (p.ex. „️🏖️ pensiun:da“, „📦 nova vaschin:a“, „🍼 genitur activ“ e.u.v.)",
    "representing_perspectives_template.description_2": "Evitai puncts da vista demografics (p. ex. „urban“, „entradas pitschnas“, „dunna“ e.u.v.) che pudessan manar a stereotips",
    "representing_perspectives_template.description_3": "Eviteschai d'attribuir a puncts da vista tschertas persvasiuns (p. ex. „persuna cun tenuta conservativa“ u „adherents“ e „adversaris“)",
    "representing_perspectives_template.description_4": "**Tscherni in emoji** per mintga punct da vista",
    "representing_perspectives_template.description_5": "Separar puncts da vista cun ina nova lingia.",
    "representing_perspectives_template.placeholder": "Definir 3-5 puncts da vista…",
    "satisfaction_survey_popover.question": "Quant cuntents essas Vus cun questa plattafurma da conversaziun?",
    "saving": "Vid arcunar…",
    "search.placeholder": "Retschertgar",
    "settings.additional_features_heading": "Funcziunalitads supplementaras",
    "settings.ai_and_manual_moderation_description": "Pretender che tut ils posts da las utilisad:ras passan l'IA e la controlla manuala avant la publicaziun.",
    "settings.ai_pre_moderation_description": "Utilisar IA per garantir che posts dals utilisaders suondan las directivas da la communitad avant la publicaziun.",
    "settings.ai_pre_moderation_with_post_anyway_description": "Permetter a las utilisa:dras da publitgar posts che l'IA giuditgescha da bassa qualitad ma betg privlus, ed als posiziunescha pli bass en il feed.",
    "settings.audience_input_description": "Rimnar dumondas, testimonis ed istorgias da las utilisad:ras. Quai po crear engaschament pli varià.",
    "settings.audience_input_label": "Input dal public (AMA)",
    "settings.blocklist_description": "Bloccar pleds specifics da tut ils posts da las utilisad:ras.",
    "settings.blocklist_label": "Glista da bloccar",
    "settings.channels_description": "Organisar spazis en channels, uschia che las squadras editorialas e da moderaziun pon sa concentrar sin cuntegns relevants.",
    "settings.channels_label": "Chanals",
    "settings.comment_slider_description": "Laschar respunder las utilisad:ras sin in spectrum.",
    "settings.comment_slider_label": "Slider da respostas",
    "settings.dialogue_description": "Laschar respunder las utilisad:ras cun in simpel 'gea' u 'na'",
    "settings.dialogue_label": "Debatta",
    "settings.heading": "Configuraziun {psiBrandName}",
    "settings.labs_description": "Formats prosocials en stadi inizial da svilup, disponibels per experimentaziun. Las funcziuns da Labs funcziunan, ma defaults standardisads mancan e la chaussa po sa midar cun il temp.",
    "settings.manual_moderation_description": "Pretender che tut ils posts da las utilisad:ras passan la controlla manuala avant la publicaziun; nagina IA per la moderaziun.",
    "settings.moderation_heading": "Moderaziun",
    "settings.prosocial_formats_description": "Mintga spazi da discussiun è structurà tenor in format prosocial.",
    "settings.representing_perspectives_description": "Laschar respunder las utilisad:ras ord in tschert punct da vista sin la dumonda.",
    "settings.representing_perspectives_label": "Preschentar puncts da vista",
    "settings.titled_writers_description": "Mussar in label tar comemb:ras verifitgadas da Voss'organisaziun cura ch'ell:as scrivan commentaris u respostas.",
    "settings.titled_writers_label": "Labels per autur:as",
    "settings.video_voting_description": "Mussar dumondas sur cuntegns da video.",
    "simple_ranking.newest": "Ils ultims",
    "single_response_help.update_response_label": "Actualisai Vossa resposta precedenta cun novas invistas.",
    "slider_with_stop_points.aria_label": "Duvrar la frizza sanestra dretga u ensi ed engiu per midar il slider",
    "sort.ascending": "A-Z",
    "sort.descending": "Z-A",
    "sort.most_recent": "Ils ultims",
    "sorting.oldest": "Ils pli vegls",
    "space.table.demo.responses": "Publicaziuns",
    "space.table.search": "Tschertgar",
    "spaces.column_comments": "Contribuziuns",
    "spaces.column_creationDate": "Creà",
    "spaces.column_name": "Num",
    "spaces.column_needs_review": "Sto vegnir controllà",
    "spaces.column_responses": "Publicaziuns",
    "spaces.column_status": "Status",
    "spaces.filter_active": "Avert",
    "spaces.filter_closed": "Serrà",
    "spaces.filter_heated": "Ardent",
    "spaces.format_required_label": "Format prosocial (obligatoric)",
    "spaces.prompt_placeholder": "Formular ina dumonda u in impuls per ina conversaziun",
    "spaces.status_active": "activ",
    "spaces.status_closed": "serrà",
    "spaces.still_need_help": "Basegn d'agid?",
    "spaces.tab_label": "Spazis",
    "spaces.title": "Spazis",
    "spaces.visit_playbook": "Visitar il PSI Playbook",
    "status.reload_to_see_effect": "Rechargiar l'artitgel per vesair l'effect",
    "strongly_agree": "D'accord",
    "strongly_disagree": "Betg d'accord",
    "survey.feedback_help": "Voss resun ans gida da far l'applicaziun pli pratica.",
    "survey.strongly_agree": "D'accord",
    "survey.strongly_disagree": "Betg d'accord",
    "survey.tell_us_experience": "Partai Vossas experientschas cun nus.",
    "survey.thank_you": "Grazia che Vus avais partì Vossas experientschas cun nus.",
    "suspension.block_user_description": "L'utilisad:ra na vegn betg pli a pudair s'annunziar per discussiuns.",
    "suspension.unblock_user_description": "L'utilisad:ra vegn puspè a pudair sa participar a discussiuns.",
    "tag.beta": "Beta",
    "template.perspectives_description": "Separar puncts da vista cun ina nova lingia.",
    "usability_survey.easy_to_use_question": "La purschida da conversaziun è simpla da duvrar",
    "usability_survey.meets_needs_question": "La purschida da debattas ademplescha mes basegns",
    "user_info.log_in_button": "As colliai (log in)",
    "video_voting.community_average": "Media en la community",
    "video_voting.discourse": "Discussiun",
    "video_voting.join_discussion": "A la discussiun",
    "video_voting.settings": "Configuraziun",
    "video_voting.time": "Temp:",
    "video_voting.you": "Vus",
    "zdf_article.manage_teaser_positions": "Administrar posiziuns da teaser",
    "zdf_article.pick_positions": "Tschernai fin 2 posiziuns",
    "zdf_article.teaser_position_last_paragraph": "Suenter l'ultim alinea en il text principal",
    "zdf_article.teaser_position_second_paragraph": "Suenter il segund alinea en il text principal",
    "zdf_article.teaser_position_second_subheading": "Suenter il segund titel intermediar en il text principal",
    "zdf_channels.add_channel_title": "Agiuntar il chanal",
    "zdf_channels.add_members": "Agiuntar commembers",
    "zdf_channels.channel_name_label": "Num dal chanal",
    "zdf_channels.default_channel_access": "Tuttas utilisad:ras dad admin han access al chanal da standard.",
    "zdf_channels.default_channel_explanation": "Tuttas administratur:as han access al chanal da standard. \n\n Novas dumondas che n'èn betg attribuidas ad in chanal specific vegnan attribuidas al chanal da standard. \n\n I po dar mo in chanal da standard.",
    "zdf_channels.delete_channel_title": "Stizzar il chanal",
    "zdf_channels.delete_confirmation": "Duai quest chanal propi vegnir stizzà?",
    "zdf_channels.edit_channel_title": "Editar il canal",
    "zdf_channels.image_url_label": "URL dal maletg dal chanal",
    "zdf_channels.member_search_field": "Champ da tschertga da commemb:ras",
    "zdf_channels.members_label": "Commemb:ras",
    "zdf_channels.super_moderator_access": "Tuts super-moderaturs han access a quest chanal.",
    "zdf_channels.use_as_default": "Duvrar sco chanal da standard",
    "zdf_moddashboard.ai_explanation": "Argumentaziun da l'IA"
}
